import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "../../components/Form/index";
import usePasswordToggle from "../../hooks copy/usePasswordToggle";
import useMuiButtonLoader from "../../hooks copy/useMuiButtonLoader";
import { loginApi } from "../../services/auth/Auth";
import toast from "react-hot-toast";
import useButtonLoader from "../../hooks/UseButtonLoader";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import MailOutlineTwoToneIcon from "@mui/icons-material/MailOutlineTwoTone";

const Login = () => {
  const navigate = useNavigate();
  const [inputType, Icon] = usePasswordToggle("small");
  const [buttonref, buttonLoader] = useButtonLoader("Login", "#28B17B");
  const [error, setError] = useState({});
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  const [login, setLogin] = useState({
    email: "",
    password: "",
  });
  const handleValidation = () => {
    const error = {};
    let status = true;

    if (!login.email) {
      error["email"] = "Please Enter Your Email";
      status = false;
    } else if (!emailRegex.test(login.email)) {
      toast.error("Please Enter Valid Email");
      status = false;
    }

    if (!login.password) {
      error["password"] = "Please Enter Your Password";
      status = false;
    }

    setError(error);
    return status;
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setLogin({ ...login, [name]: value });
    // console.log(name, value);
  };

  const admiLogin = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      try {
        buttonLoader(true);
        const res = await loginApi(login);

        console.log(res, "response");
        // console.log("res login",res)
        if (res.data.status === 200) {
          localStorage.setItem("community_token", res?.data?.data?.token);
          localStorage.setItem(
            "neptuneAdmin",
            JSON.stringify({
              name: "Neptune",
              role: "admin",
              username: "neptune_123",
              profile: "",
              // admin: res?.data?.data?.user,
            })
          );
          localStorage.setItem("communityId", res?.data?.data?.user?._id);
          localStorage?.removeItem("email");
          toast.success(res.data.message);
          navigate("/dashboard");
          buttonLoader(false);
        } else {
          toast.error(res.data.message);
          buttonLoader(false);
        }
      } catch (error) {
        toast.error(e.message);
        buttonLoader(false);
      }
    }
  };

  return (
    <>
      <div className="LoginArea">
        <h1 className="login_head">Neptune</h1>
        <div className="LoginBox">
          <h5 className="mt-2">Login here</h5>
          <form>
            <div className="form-group">
              <Input
                label={"Email ID"}
                type="text"
                name="email"
                value={login.email}
                onChange={onChangeHandler}
                placeholder="Enter Email ID"
                className={`form-control `}
                error={error.email}
                maxLength={40}
                leftIcon={
                  <span className="Icon">
                    <MailOutlineTwoToneIcon />
                  </span>
                }
              />
            </div>

            <div className="form-group">
              <Input
                type={inputType}
                name="password"
                value={login.password}
                onChange={onChangeHandler}
                placeholder="Enter Password"
                className={`form-control password`}
                label={"Password"}
                error={error.password}
                // maxLength={15}
                leftIcon={
                  <span className="Icon">
                    <LockOpenTwoToneIcon />
                  </span>
                }
              />
              <span className="icon">{Icon}</span>
            </div>

            <div className="Checkboxs">
              <Link to="/forgot-password">forgot password?</Link>
            </div>

            <div className="form_btn">
              <button className="login_btn" ref={buttonref} onClick={admiLogin}>
                Log In <i className="fa fa-sign-in"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;
